import styled from 'styled-components';

const ReactionsListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  height: calc(100% - 350px);
  overflow: auto;
  padding: 16px;
  position: relative;
`;

const NoReactionsFoundContainer = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
  justify-content: center;
  align-items: center;
  color: #445260;
`;

const ReactionsContainer = styled.div`
  height: 100%;
`;

export default {
  ReactionsContainer,
  ReactionsListContainer,
  NoReactionsFoundContainer,
};
